import BaseBehavior from '../../../framework/base/base';
import { showElement, hideElement } from '../../../shared/utilities/show-hide';
import { debounce } from '../../../shared/utilities/debounce';

export function compareWidth(scrollWidth, clientWidth, padding) {
	return scrollWidth > clientWidth + padding;
}

export function getNumericValue(str) {
	return str ? Number(str.match(/\d+/)[0]) : 0;
}
export default class TableSwipe extends BaseBehavior {
	constructor(element) {
		super(element);

		this.checkIndicatorVisibility();

		const handleResizeDebounced = debounce(() => {
			this.checkIndicatorVisibility();
		}, 250).bind(this);

		this.addEventListener(window, 'resize', handleResizeDebounced);
	}

	isOverflown(element) {
		const parentWrapper = element.closest('.v2-wrapper');
		const paddingStr = window.getComputedStyle(parentWrapper).getPropertyValue('padding-right');
		const paddingValue = getNumericValue(paddingStr);

		return compareWidth(element.scrollWidth, element.clientWidth, paddingValue);
	}

	checkIndicatorVisibility() {
		const tableOverflowContainer = this.element.querySelector('.v2-responsive-table__content');
		const swipeIndicator = this.element.querySelector('.swipe-indicator');
		this.isOverflown(tableOverflowContainer)
			? showElement(swipeIndicator)
			: hideElement(swipeIndicator);
	}

	removeEventListeners() {
		this.removeEventListener(window, 'resize');
	}

	cleanup() {
		this.removeEventListeners();
	}
}
